export interface InteriorPreviewItem {
  src: string;
  title: string;
  text: string;
  origin: string;
  badge?: string;
}

export const interiorPreviewItems: InteriorPreviewItem[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/3DCQnmTRnLxxi3Fc8SEZrL/01-sesion-organizada.webp',
    title: 'Un entrenamiento con un objetivo claro',
    text: 'Primera página de una sesión de 75 minutos: material, activación y tareas con tiempos y organización.',
    badge: 'Sesión completa · Parte 1 de 2',
    origin: 'Bono 3, página 39'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jaruKghrq99nnhp6xx1QCe/02-sesion-juego-y-correcciones.webp',
    title: 'Del ejercicio al juego del equipo',
    text: 'Continuación de la misma sesión: juego 6 contra 6, errores frecuentes, ajustes y cierre.',
    badge: 'La misma sesión · Parte 2 de 2',
    origin: 'Bono 3, página 40'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tF9obaDNx6wUn1NjLos3z7/03-tecnica-recepcion.webp',
    title: 'Observa el gesto y elige qué corregir',
    text: 'Recepción y defensa ilustradas, con claves de observación y una pauta para comprobar la corrección.',
    origin: 'Tomo 2, página 24'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aRkFhXPqAjFNUCr6m1Hmex/04-rotacion-sistema-5-1.webp',
    title: 'Explica la rotación con una referencia visual',
    text: 'Dos momentos de una rotación del sistema 5-1, con ensayo, error frecuente y adaptación.',
    origin: 'Tomo 5, página 5'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rZ5Y4TJuCtDK8mdPxLhG6B/06-registro-imprimible.webp',
    title: 'Registra lo que funciona y decide el siguiente paso',
    text: 'Ficha imprimible para anotar acciones útiles, ajustes y qué mantener en la próxima sesión.',
    origin: 'Tomo 6, página 32'
  }
];
